import { AUTHORIZATION_HEADER } from '../../../../src/authorization';
import { send } from '../../../../src/network';
import { type Experiment } from '../../../../src/types/Experiment';
import { type Paginated } from '../../../../src/types/Paginated';

export { type Experiment };

export type ExperimentsResponse = Paginated<Experiment>;
export interface GetExperimentsParams {
  limit?: number;
  offset?: number;
}

export function getExperiments(params: GetExperimentsParams = {}) {
  const { limit, offset } = params;
  const query = new URLSearchParams();
  if (limit !== undefined) {
    query.append('limit', limit.toString());
  }

  if (offset !== undefined) {
    query.append('offset', offset.toString());
  }

  query.append('is_active', 'true'); // only fetch active experiments to reduce records by hundreds

  return send<ExperimentsResponse>({
    method: 'GET',
    path: '/api/v2/experiments/',
    query,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
